/**
 * "Vertretung bestätigt": channel of the confirmation (WhatsApp / E-Mail / both) for the dialog "Zusage eintragen", the
 * row of the selected substitute and the Verlauf. Pure, no Vue.
 */
export type ConfirmationChannel = 'whatsApp' | 'mail' | 'both';

/** "per WhatsApp" / "per E-Mail" / "per WhatsApp und E-Mail" */
export function confirmationChannelText(channel: ConfirmationChannel | null | undefined): string {
  return channel === 'both' ? 'per WhatsApp und E-Mail' : channel === 'mail' ? 'per E-Mail' : 'per WhatsApp';
}

/** Channel of a sent confirmation (stored message ids); older confirmations without ids: WhatsApp (mail did not exist) */
export function sentConfirmationChannel(c: { confirmationWhatsApp?: unknown; confirmationMail?: unknown }): ConfirmationChannel {
  if (c.confirmationWhatsApp && c.confirmationMail) {
    return 'both';
  }
  return c.confirmationMail ? 'mail' : 'whatsApp';
}

/** "Bestätigung per E-Mail gesendet" of the selected substitute, else the reason why not ("Bestätigung nicht gesendet – …") */
export function confirmationStateText(c: { confirmationSentAt?: unknown; confirmationSkipped?: string | null; confirmationWhatsApp?: unknown; confirmationMail?: unknown }): string {
  return c.confirmationSentAt ? `Bestätigung ${confirmationChannelText(sentConfirmationChannel(c))} gesendet` : c.confirmationSkipped || '';
}
